import { useLocalStorageStore } from '@/store/localStorageStore';
import { useGtm } from '@gtm-support/vue-gtm';
import { appSettings } from '@/appSettings';

type UseAnalyticsReturn = {
    init: (overrideDev?: boolean) => void;
};

export function useAnalytics(): UseAnalyticsReturn {
    const isDev = import.meta.env.DEV === true;
    const localStorageStore = useLocalStorageStore();
    const gtm = useGtm();

    function init(): void {
        if (appSettings.analyticsKey === '') {
            console.info('Analytics key is not set');
            return;
        }

        if (isDev && localStorageStore.enableAnalytics === false) {
            console.info({ cat: 'Analytics', msg: 'Analytics disabled in development mode' });
            return;
        }

        gtm?.enable(true);
    }

    return {
        init
    };
}
